module.exports = __webpack_public_path__ + "static/stanford-acc33ac954ed132a16c5e0464c299092.jpeg";